import { render, staticRenderFns } from "./summarybox.vue?vue&type=template&id=0f05eb46&scoped=true&"
import script from "./summarybox.vue?vue&type=script&lang=js&"
export * from "./summarybox.vue?vue&type=script&lang=js&"
import style0 from "./summarybox.vue?vue&type=style&index=0&id=0f05eb46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05eb46",
  null
  
)

export default component.exports